import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useValidator } from "react-joi";
import { updateExhangeRate } from "../../../../components/joi/settingsModalsSchema";
import { changeExchangeSetData } from "../../../../context/api/settings/change-exchange/changeExchangeSetData";
import { getExchangeApi } from "../../../../context/api/settings/get-values/getExhangeApi";
import { joiErrorMessage } from "../../extra/joiErrorMessage";
// FontAwesomeIcon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretUp,
  faCaretDown
} from "@fortawesome/free-solid-svg-icons";
// bootstrap
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { InputGroup } from "react-bootstrap";

const ChangeExchange = ({
  dataTransalte,
  onHide,
  lang,
  setMessageResponse,
}) => {
  const schema = updateExhangeRate(lang).schema;
  const { state, setData, setExplicitField, validate } = useValidator(schema);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);
  const [exchange, setExchange] = useState({
    data: {},
    loader: true,
  });
  
  useEffect( () => {
    const fetch = async () => {
      await getExchangeApi(lang, cookies, setExchange, setMessageResponse , setData);
    };
    fetch();
    // setData(exchange.data)
  }, []);

  const updateDinar = (e) => {
    setData((old) => ({
      ...old,
      dinar: e.target.value,
    }));
  };

  const updateRMB = (e) => {
    setData((old) => ({
      ...old,
      RMB: e.target.value,
    }));
  };

  const postData = async (e) => {
    e.preventDefault();
    const credintial = {
      dinar: state.$data.dinar,
      RMB: state.$data.RMB,
    };
    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return changeExchangeSetData(
        lang,
        credintial,
        setMessageResponse,
        cookies,
        setBtnLoader,
        setExchange
      );
    }
  };

  return (
    <>
      <Modal.Header>
        <Modal.Title className="d-flex flex-column align-items-center w-100 fs-2">
          {dataTransalte.popups.settings.update_exchange_rate}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex gap-3 flex-column align-items-center justify-content-center"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {exchange.loader ? (
          <Spinner animation="border" variant="warning" className="my-5" />
        ) : (
          <>
            <Form.Group
              className=" d-flex flex-column align-items-center w-50"
              controlId="formBasicEmail"
            >
              <Form.Label>
                {dataTransalte.popups.settings.dinar_to_dollar}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  defaultValue={exchange.data.dinar.rate || 0}
                  onChange={updateDinar}
                  onBlur={() => setExplicitField("dinar", true)}
                  className="defaultControl"
                />
                <InputGroup.Text
                  className="arrow">
                  <FontAwesomeIcon
                    icon={
                      (exchange.data.dinar.status === 'higher' ? faCaretUp : faCaretDown)
                      }
                    size="xl"
                    className={
                      (exchange.data.dinar.status === 'higher' ? 'greenArrow' : 'redArrow')
                    }
                  />
                </InputGroup.Text>
              </InputGroup>

              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.dinar)}
              </Form.Text>
            </Form.Group>

            <Form.Group
              className="mb-3 d-flex flex-column align-items-center w-50"
              controlId="formBasicEmail"
            >
              <Form.Label>
                {dataTransalte.popups.settings.RMB_to_dollar}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  defaultValue={exchange.data.RMB.rate || 0}
                  onChange={updateRMB}
                  onBlur={() => setExplicitField("RMB", true)}
                  className="defaultControl"
                />
                <InputGroup.Text className="arrow">
                  {/* {exchange.data.RMB.status} */}
                  <FontAwesomeIcon
                    icon={(exchange.data.RMB.status === 'higher' ? faCaretUp : faCaretDown)}
                    size="xl"
                    className={
                      (exchange.data.RMB.status === 'higher' ? 'greenArrow' : 'redArrow')
                    }
                  />
                </InputGroup.Text>
              </InputGroup>
              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.RMB)}
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Modal.Body>

      <Modal.Footer className="w-100 d-flex flex-row align-items-center">
        <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
          <Button
            onClick={(e) => {
              validate();
              postData(e);
            }}
            disabled={btnLoader ? true : false}
          >
            {dataTransalte.pages.navbar.settings.update}
          </Button>
          <Button onClick={onHide}>
            {dataTransalte.pages.navbar.settings.close}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default ChangeExchange;
